
export default function HeroSection() {
  const handleCTAClick = () => {
    const ctaSection = document.getElementById('cta-section');
    ctaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.8), rgba(30, 64, 175, 0.6)), url('https://public.readdy.ai/ai/img_res/fb6ee6f97091027878d16dc792147726.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            ドライバー採用を<br />
            <span className="text-blue-300">最短で成功へ</span>
          </h1>
          
          <div className="mb-8">
            <div className="inline-block bg-white/20 backdrop-blur-sm rounded-lg px-6 py-3 mb-6">
              <span className="text-2xl font-semibold" style={{ fontFamily: '"Pacifico", serif' }}>
                ドライバー集客
              </span>
            </div>
          </div>

          <p className="text-xl md:text-2xl mb-8 font-medium">
            <strong>Indeed・スタンバイ・求人ボックス</strong>の<br />
            応募最大化で採用課題を解決
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <div className="flex items-center text-lg">
              <i className="ri-check-line text-blue-300 mr-2 text-xl"></i>
              運送業界特化
            </div>
            <div className="flex items-center text-lg">
              <i className="ri-check-line text-blue-300 mr-2 text-xl"></i>
              応募数3倍UP実績
            </div>
            <div className="flex items-center text-lg">
              <i className="ri-check-line text-blue-300 mr-2 text-xl"></i>
              無料相談実施中
            </div>
          </div>

          <button 
            onClick={handleCTAClick}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-lg text-xl transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            今すぐ無料相談を申し込む
          </button>

          <p className="mt-4 text-sm opacity-90">
            ※ 相談は完全無料です。しつこい営業は一切いたしません。
          </p>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
